export default {
      id: "eye-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#eye",
      toString: function () {
        return this.url;
      }
    }